import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCropFavorite } from '../../../../api/crop-trends/mutations/deleteCropFavorite';

export const useDeleteCropFavorite = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteCropFavorite, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['crop-favorite'] });
      queryClient.invalidateQueries({ queryKey: ['favorite-crop-prices'] });
    },
  });
};
